import { createFileRoute, notFound } from "@tanstack/react-router";

import { TravelView } from "@/components/pages/TravelView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/travel/")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/travel",
          ...meta[params.locale].travel,
        })
      : {},
  component: TravelRoute,
});

function TravelRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <TravelView locale={locale} />;
}
